/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feedback_EmptyInputs */

const es_feedback_empty = /** @type {(inputs: Feedback_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay feedbacks todavía`)
};

const en_feedback_empty = /** @type {(inputs: Feedback_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`There are no feedback entries yet`)
};

/**
* | output |
* | --- |
* | "There are no feedback entries yet" |
*
* @param {Feedback_EmptyInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const feedback_empty = /** @type {((inputs?: Feedback_EmptyInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_EmptyInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_feedback_empty(inputs)
	return en_feedback_empty(inputs)
});
export { feedback_empty as "feedback.empty" }